import { Block } from 'framework7-react';
import React, { FC } from 'react';
import styles from './ScoreDetailsStyle.module.css';
import { PopupPageTemplate } from '@/components/uiParts/Template/PopupPageTemplate/PopupPageTemplate';

export const ScoreDetails: FC = () => {
  return (
    <PopupPageTemplate
      pageName="score"
      title={
        <>
          安全運転スコア(累計)100点を
          <br />
          獲得したい
        </>
      }
    >
      <Block>
        <div className={styles.sst} role="region" aria-labelledby="sst-title">
          <h2 id="sst-title" className={styles.visuallyHidden}>
            安全運転スコア（累計）100点を獲得したい
          </h2>

          <section className={styles.qa}>
            <p className={styles.q}>
              <span className={styles.label}>Q.</span>
              <span className={styles.text}>
                1回でも安全運転スコアが低かったら100点は獲得できないのでしょうか？
              </span>
            </p>

            <p className={styles.a}>
              <span className={styles.label}>A.</span>
              <span className={styles.lead}>
                いいえ、そんなことはありませんので、ご安心ください！
              </span>
            </p>

            <p className={styles.body}>
              運転特性判定を決定する安全運転スコアは、運転特性計測期間における通常の
              「速度超過・急アクセル・急ブレーキ」の発生頻度によって算出する仕組みとなっています。
              1回ごとや1日の安全運転スコアの平均点ではありませんので、その後の安全運転スコアは改善できます。
              交通ルールを守って安全運転を心がけ、100点獲得を目指しましょう！
            </p>
          </section>
        </div>
      </Block>
    </PopupPageTemplate>
  );
};
